import { render, staticRenderFns } from "./email-confirmation.vue?vue&type=template&id=6ae0bbe7"
import script from "./email-confirmation.vue?vue&type=script&lang=js"
export * from "./email-confirmation.vue?vue&type=script&lang=js"
import style0 from "./email-confirmation.vue?vue&type=style&index=0&id=6ae0bbe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports